import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "netplatform-config"
};
const _hoisted_2 = {
  class: "toolbox"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增服务商品");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("关键词编辑");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除");

import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { getVexTableProps } from '@/config';
import { ElMessage, ElMessageBox } from 'element-plus';
import ProdKeyModal from './netplatform-prodkeymodal';
import ProdAddModal from './netplatform-addprodmodal';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'netplatformConfig',
  props: {
    actDept: {
      type: Object,
      default: () => ({})
    }
  },

  setup(__props) {
    const props = __props;
    const route = useRoute();
    onMounted(() => getList()); // watch(
    //     () => props.actDept.supplierId,
    //     () => getList()
    // )

    const table = ref([]);

    function getList() {
      let params = {
        supplierId: route.query.supplierId
      };
      Axios.get('/admin/supplier/getSpiderkeyword', {
        params
      }).then(res => {
        let {
          success,
          data
        } = res.data;

        if (success) {
          table.value = data.rows.map(v => {
            v.prodKeywords = v.prodKeywordList.join();
            v.manufactureKeywords = v.manufactureKeywordList.join();
            return v;
          });
        }
      });
    }

    function deleteHandle(item) {
      ElMessageBox.confirm('确认删除吗？', '删除', {
        type: 'warning'
      }).then(() => {
        let body = {
          supplierId: route.query.supplierId,
          prodNo: item.prodNo
        };
        Axios.post('/admin/supplier/deleteSpiderkeyword', body).then(res => {
          let {
            success,
            msg
          } = res.data;

          if (success) {
            ElMessage.success('操作成功');
            getList();
            return;
          }

          ElMessage.error(msg);
        });
      });
    }

    const modal = ref({
      show: false
    });

    function editAction(item) {
      modal.value = _objectSpread({
        show: true
      }, item);
    }

    const addModal = ref({
      show: false
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => addModal.value.show = true)
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      })]), _createVNode(_component_el_table, {
        data: table.value
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "商品名称",
          prop: "prodName"
        }), _createVNode(_component_el_table_column, {
          label: "商品搜索关键词",
          prop: "prodKeywords"
        }), _createVNode(_component_el_table_column, {
          label: "厂家",
          prop: "manufacture"
        }), _createVNode(_component_el_table_column, {
          label: "厂家搜索关键词",
          prop: "manufactureKeywords"
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            link: "",
            onClick: $event => editAction(scope.row)
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "primary",
            link: "",
            onClick: $event => deleteHandle(scope.row)
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(_unref(ProdKeyModal), {
        modelValue: modal.value.show,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => modal.value.show = $event),
        data: modal.value,
        supplierId: _unref(route).query.supplierId,
        onSuccess: getList
      }, null, 8, ["modelValue", "data", "supplierId"]), _createVNode(_unref(ProdAddModal), {
        modelValue: addModal.value.show,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => addModal.value.show = $event),
        dept: __props.actDept,
        supplierId: _unref(route).query.supplierId,
        selectedData: table.value,
        onSuccess: getList
      }, null, 8, ["modelValue", "dept", "supplierId", "selectedData"])]);
    };
  }

};